import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@redux/reducer';
import courseActions from '@redux/course/actions';

const { fetchCourseCertificateBundlesAction } = courseActions;

export const useCourseCertificateBundles = () => {
  const dispatch = useDispatch();
  const { courseCertificateBundlesState } = useSelector((state: RootState) => ({
    courseCertificateBundlesState: state.Course.get('courseCertificateBundlesState'),
  }));

  const handleFetchCourseCertificateBundles = (courseId: number) => {
    dispatch(fetchCourseCertificateBundlesAction.request({ courseId }));
  };

  const courseCertificateBundlesData = courseCertificateBundlesState?.data || [];

  return {
    handleFetchCourseCertificateBundles,
    courseCertificateBundlesData,
  };
};
